import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/ProductListing/ProductListing.js
const ProductListing = () => (
  <NoSettings text="Product grid with filters. On category, brand and catalog pages it lists that page's products. No settings." />
);

export default ProductListing;
